import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';

const WhitelabelIcon = ({ className, ...props }: IProps) => {
  const iconClassName = classNames('whitelabel-icon', className);

  return (
    <svg className={iconClassName} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.25 3C2.25 2.58579 2.58579 2.25 3 2.25H21C21.4142 2.25 21.75 2.58579 21.75 3V8.25H2.25V3ZM8.00898 4.25H6V6.25H8.00898V4.25ZM12.009 4.25H10V6.25H12.009V4.25Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.75 9.75H21.75V21C21.75 21.1989 21.671 21.3897 21.5303 21.5303C21.3897 21.671 21.1989 21.75 21 21.75L9.75 21.75V9.75ZM19 14.5H13V13H19V14.5ZM16 18.5H13V17H16V18.5Z'
        fill='currentColor'
      />
      <path d='M8.25 9.75H2.25V21C2.25 21.4142 2.58579 21.75 3 21.75H8.25V9.75Z' fill='currentColor' />
    </svg>
  );
};

export default WhitelabelIcon;
